"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PluginsService", {
    enumerable: true,
    get: function() {
        return PluginsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _models = require("~/models");
const _utils = require("~/helpers/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let PluginsService = class PluginsService {
    async pluginList() {
        return await _models.Plugin.list();
    }
    async pluginTest(param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/PluginTestReq', param.body);
        this.appHooksService.emit(_nocodbsdk.AppEvents.PLUGIN_TEST, {
            testBody: param.body,
            req: param.req
        });
        return await _NcPluginMgrv2.default.test(param.body);
    }
    async pluginRead(param) {
        return await _models.Plugin.get(param.pluginId);
    }
    async pluginUpdate(param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/PluginReq', param.plugin);
        const pluginInfo = await _models.Plugin.get(param.pluginId);
        if ((pluginInfo == null ? void 0 : pluginInfo.title) && pluginInfo.category && !(0, _utils.isPlayWrightNode)()) {
            await _NcPluginMgrv2.default.test({
                title: pluginInfo.title,
                category: pluginInfo.category,
                input: param.plugin.input
            });
        }
        const plugin = await _models.Plugin.update(param.pluginId, param.plugin);
        this.appHooksService.emit(plugin.active ? _nocodbsdk.AppEvents.PLUGIN_INSTALL : _nocodbsdk.AppEvents.PLUGIN_UNINSTALL, {
            plugin,
            req: param.req
        });
        return plugin;
    }
    async isPluginActive(param) {
        return await _models.Plugin.isPluginActive(param.pluginId);
    }
    async webhookPluginList() {
        const plugins = await _models.Plugin.list();
        return plugins.filter((p)=>[
                'Slack',
                'Microsoft Teams',
                'Discord',
                'Mattermost'
            ].includes(p.title));
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
PluginsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], PluginsService);
